import React from "react";
import "../../../index.css";
import "../../../App.css";
import DownloadImage from "../../../helper/images/DownloadApp.png";
import { Link } from "react-router-dom";
import Googleplay from "../../../helper/svg/googleplay.svg";
import Appstore from "../../../helper/svg/appstore.svg";
import App1 from "../../../helper/images/App1.png";
import AppImages from "../../../helper/images/AppImages.png";
import { useTranslation } from "../../../hooks/useTranslation";
const DownloadApp = () => {
  const { t } = useTranslation();
  return (
    <>
      <div
        className=""
        style={{
          backgroundImage: "url(" + DownloadImage + ")",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="container relative">
          <div className="grid grid-cold-1 md:grid-cols-2 gap-5 md:gap-[34px] ">
            <div className="2xl:py-[139px] lg:py-[100px] md:py-[70px] py-[30px]">
              <h2 className="text-white 2xl:text-[48px] xl:text-[35px] md:text-[30px] text-[25px] font-semibold 2xl:leading-[56px] leading-9 lg:mb-[30px]">
                {t("home").downloadApp.title}
              </h2>
              <div className="flex items-center gap-[13px] w-full md:mt-[48px] mt-5">
                <Link to="/" className="">
                  <img
                    src={Googleplay}
                    alt="download"
                    className="w-full h-full object-cover"
                  />
                </Link>
                <Link to="/" className="">
                  <img
                    src={Appstore}
                    alt="download"
                    className="w-full h-full object-cover"
                  />
                </Link>
              </div>
            </div>
            <div className="md:absolute xl:top-[-70px] md:top-0 2xl:right-[-80px] md:right-0 animate-waveY md:block hidden z-0">
              <img
                src={AppImages}
                alt="download"
                className="w-full 2xl:max-w-[800px] xl:max-w-[700px] lg:max-w-[600px] md:max-w-[450px] max-w-full"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DownloadApp;
